import { usePublicFeatureFlags } from '@/shared/api/featureFlagsQueries'

export function useTombolaEnabled(): boolean {
  const flagsQuery = usePublicFeatureFlags()
  const lottery = flagsQuery.data?.find((row) => row.module_name === 'lottery')
  const raw = lottery?.metadata?.tombola_enabled

  if (typeof raw === 'boolean') {
    return raw
  }

  return false
}
